import React                    from 'react';
import { useEffect }            from 'react';
import { useRef }               from 'react';
import { useState }             from 'react';
import { useDispatch }          from 'react-redux';
import { useSelector }          from 'react-redux';
import { Formik }               from 'formik';
import Swal                     from 'sweetalert2';
import * as yup                 from 'yup';

import clienteAxios             from '../../../config/axios';

import { Alert }                from 'react-bootstrap';
import { Button }               from 'react-bootstrap';
import { Form }                 from 'react-bootstrap';
import { Modal }                from 'react-bootstrap';

import { ICON_CANCEL }          from '../../extras/icons';
import { ICON_SAVE }            from '../../extras/icons';

import { ACCESO_RESERVADAS }    from '../../../data/objects';
import Authorities              from '../../../services/AuthoritiesService';
import binaryData               from '../../../data/binaryData';
import ButtonSpinner            from '../../layout/ButtonSpinner';
import { ErrorMessage }         from '../../../components/extras/toastMessages';
import { WaitingMessage }       from '../../../components/extras/toastMessages';

import { saveUsersAction }      from '../../../actions/usersActions';
import { updateUsersAction }    from '../../../actions/usersActions';



const UserForm = props => {


    // ============================================================================================
    // DECLARACIONES ------------------------------------------------------------------------------
    // ============================================================================================

    // Tomo los props
    const { show, handleClose } = props;

    // Genero los refs
    const refApellido = useRef();

    // Datos iniciales
    const initialData = {
        apellido: '',
        email: '',
        legajo: '',
        nivel: '',
        nombre: '',
        ofiju: '',
        perfil: '',
        privadas: '0',
        unidad: '',
    }

    // Inicializo el dispatch
    const dispatch = useDispatch();

    // Traigo el store
    const authorities = useSelector( state => state.auth.authorities );
    const authUser = useSelector( state => state.auth.user );
    const isEdit = useSelector( state => state.users.isEdit );
    const usersLoading = useSelector( state => state.users.loadingSave );
    const userSelected = useSelector( state => state.users.userSelected );
    
    // Inicializo el state local
    const [levels, setLevels] = useState(null);
    const [ofijus, setOfijus] = useState(null);
    const [profiles, setProfiles] = useState(null);
    const [units, setUnits] = useState(null);
    const [user, setUser] = useState(initialData);



    // ============================================================================================
    // FUNCIONES ----------------------------------------------------------------------------------
    // ============================================================================================

    // Manejo de cambios
    const handleChange = e => {
        setUser({
            ...user,
            [e.target.name]: e.target.value
        })
    }
    
    // Manejo cierre de la ventana
    const handleCloseForm = e => {
        //Reinicio datos
        setUser(initialData);
        //Cierro
        handleClose();
    }
    
    // Manejo cuando se muestra
    const handleOnShow = e => { 
        //Me fijo si hay datos de niveles
        if(!levels)
        {   loadLevels();
        }
        //Me fijo si hay datos de ofijus
        if(!ofijus)
        {   loadOfijus();
        }
        //Me fijo si hay datos de perfiles
        if(!profiles)
        {   loadProfiles();
        }
        //Me fijo si hay datos de unidades
        if(!units)
        {   loadUnits();
        }
        //Pongo el foco en el primer campo
        refApellido.current.focus();
    }
    
    // Manejo el guardado
    const handleSave = values => {
        // Armo el objeto de datos
        let data = {
            apellido: values.apellido,
            nombre: values.nombre,
            legajo: values.legajo,
            email: values.email,
            perfil: {
                id: values.perfil
            },
            nivel: {
                id: values.nivel
            },
            unidad: {
                id: values.unidad
            },
            activo: 1
        }
        // Me fijo si hay ofiju
        if(values.ofiju && values.ofiju != "")
        {   data = {
                ...data,
                ofiju: {
                    id: values.ofiju
                }
            }
        }
        if(authUser && Authorities.hasPermission(authorities, ACCESO_RESERVADAS))
        {   // Agrego el permiso de privadas
            data = {
                ...data,
                privadas: parseInt(values.privadas)
            }
        }
        // Verifico si es edición o alta
        if(user.id)
        {   // Se agrega al ID
            data = {
                id: user.id,
                ...data,
                privadas: typeof data.privadas !== "undefined" ? data.privadas : user.privadas
            }
            // Es edición
            dispatch( updateUsersAction(data, handleCloseForm) );
        }
        else
        {   //Es creación
            dispatch( saveUsersAction(data, handleCloseForm) );
        }
    }

    // Cargo los datos de los Select
    const loadLevels = async () => {
        try
        {   WaitingMessage('Cargando parámetros');
            const resp = await clienteAxios.get(`/nivel/activo`);
            setLevels(resp.data);
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            Swal.close();
            ErrorMessage(data.message);
        }
    }
    const loadOfijus = async () => {
        try
        {   WaitingMessage('Cargando parámetros');
            const resp = await clienteAxios.get(`/ofiju/activo`);
            setOfijus(resp.data);
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            Swal.close();
            ErrorMessage(data.message);
        }
    }
    const loadProfiles = async () => {
        try
        {   WaitingMessage('Cargando parámetros');
            const resp = await clienteAxios.get(`/usuario/perfiles`);
            setProfiles(resp.data);
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            Swal.close();
            ErrorMessage(data.message);
        }
    }
    const loadUnits = async () => {
        try
        {   WaitingMessage('Cargando parámetros');
            const resp = await clienteAxios.get(`/unidad/activo`);
            setUnits(resp.data);
            Swal.close();
        }
        catch(error)
        {   const response = error.response;
            let data = {
                data: null,
                message: 'Error al conectarse al servidor'
            };
            if(response)
            {   data = response.data;
            }
            Swal.close();
            ErrorMessage(data.message);
        }
    }
    
    // Modifico según el cambio
    useEffect(() => {
        // Me fijo si es edición
        if(isEdit && userSelected)
        {   setUser(userSelected);
            setUser({
                ...userSelected,
                nivel: userSelected.nivel ? userSelected.nivel.id : '',
                perfil: userSelected.perfil ? userSelected.perfil.id : '',
                ofiju: userSelected.ofiju ? userSelected.ofiju.id : '',
                unidad: userSelected.unidad ? userSelected.unidad.id : '',
            });
        }
        else
        {   setUser(initialData);
        }        
        // eslint-disable-next-line
    }, [isEdit, userSelected, show]) 
    
    //Esquema de validación
    const validationSchema = yup.object({
        apellido: yup.string().required(),
        nombre: yup.string().required(),
        legajo: yup.number().required(),
        email: yup.string().email().required(),
        perfil: yup.number().required(),
        nivel: yup.number().required(),
        ofiju: yup.number().nullable(),
        unidad: yup.number().required()
    });
    


    // ============================================================================================
    // RENDERIZO ----------------------------------------------------------------------------------
    // ============================================================================================

    return (
        <Modal 
            aria-labelledby = "contained-modal-title-vcenter" 
            centered
            onHide = { handleCloseForm } 
            onShow = { handleOnShow } 
            show = { show } 
            size = "lg"
        >
            <Modal.Header closeButton>
                <Modal.Title>
                    Usuario&nbsp;
                    <small><strong>{ isEdit ? 'Editar' : 'Nuevo' } Registro</strong></small>
                </Modal.Title>
            </Modal.Header>
            <Formik
                enableReinitialize
                validationSchema = { validationSchema }
                initialValues = {{ ...user }}
                onSubmit = { values=>handleSave(values) }
            >
                {({
                    handleSubmit,
                    handleChange,
                    handleBlur,
                    values,
                    touched,
                    isValid,
                    errors,
                    isSubmitting
                }) => (
                    <form noValidate onSubmit={handleSubmit} autoComplete="off">
                        <Modal.Body>
                            <div className="row">
                                <div className="col-12">
                                    <Alert variant="info">
                                        Al generar un usuario se le asignará una <strong>contraseña automática</strong>, que le <strong>llegará por mail al destinatario</strong>. El mismo la deberá cambiar al ingresar por primera vez al sistema.
                                    </Alert>
                                </div>
                            </div>
                            <div className="row">
                                <Form.Group className="col-md-6">
                                    <label htmlFor="apellido">Apellido</label>
                                    <Form.Control
                                        autoFocus
                                        className = "form-control"
                                        disabled = { usersLoading }
                                        id = "apellido"
                                        isInvalid = { !!errors.apellido }
                                        name = "apellido" 
                                        onChange = { handleChange }
                                        ref = { refApellido }
                                        type = "text" 
                                        value = { values.apellido }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.apellido }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="nombre">Nombre</label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { usersLoading }
                                        id = "nombre"
                                        isInvalid = { !!errors.nombre }
                                        name = "nombre" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.nombre }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.nombre }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-4">
                                    <label htmlFor="legajo">Legajo</label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { usersLoading }
                                        id = "legajo"
                                        isInvalid = { !!errors.legajo }
                                        name = "legajo"
                                        onChange = { handleChange } 
                                        type = "text" 
                                        value = { values.legajo }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.legajo }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-8">
                                    <label htmlFor="email">Email</label>
                                    <Form.Control
                                        className = "form-control" 
                                        disabled = { usersLoading }
                                        id = "email" 
                                        isInvalid = { !!errors.email }
                                        name = "email" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.email }
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        { errors.email }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="perfil">Perfil</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control" 
                                        disabled = { usersLoading }
                                        id = "perfil" 
                                        isInvalid = { !!errors.perfil }
                                        name = "perfil" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.perfil }
                                    >
                                        <option value="">Seleccione el Perfil</option>
                                        {   profiles 
                                                ?
                                                    profiles.map( profile=>(
                                                        <option key={`up${profile.id}`} value={profile.id} >
                                                            { profile.descripcion }
                                                        </option>
                                                    ))
                                                : 
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.perfil }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-6">
                                    <label htmlFor="nivel">Nivel</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control"  
                                        disabled = { usersLoading }
                                        id = "nivel"
                                        isInvalid = { !!errors.nivel }
                                        name = "nivel" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.nivel }
                                    >
                                        <option value="">Seleccione el Nivel</option>
                                        {   levels 
                                                ?
                                                    levels.map( level=>(
                                                        <option key={`ul${level.id}`} value={level.id} >
                                                            { level.descripcion }
                                                        </option>
                                                    ))
                                                : 
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.level }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="ofiju">OFIJU a la que pertenece</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control" 
                                        disabled = { usersLoading }
                                        id = "ofiju" 
                                        isInvalid = { !!errors.ofiju }
                                        name = "ofiju" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.ofiju }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   ofijus 
                                                ?
                                                    ofijus.map( ofiju=>(
                                                        <option key={`uo${ofiju.id}`} value={ofiju.id} >
                                                            { ofiju.nombre }
                                                        </option>
                                                    ))
                                                : 
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.ofiju }
                                    </Form.Control.Feedback>
                                </Form.Group>
                                <Form.Group className="col-md-12">
                                    <label htmlFor="unidad">Unidad Judicial</label>
                                    <Form.Control
                                        as = "select"
                                        className = "form-control"  
                                        disabled = { usersLoading }
                                        id = "unidad"
                                        isInvalid = { !!errors.unidad }
                                        name = "unidad" 
                                        onChange = { handleChange }
                                        type = "text" 
                                        value = { values.unidad }
                                    >
                                        <option value="">Seleccione...</option>
                                        {   units 
                                                ?
                                                    units.map( unit=>(
                                                        <option key={`uu${unit.id}`} value={unit.id} >
                                                            { unit.descripcion }
                                                        </option>
                                                    ))
                                                : 
                                                    null
                                        }
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        { errors.unit }
                                    </Form.Control.Feedback>
                                </Form.Group>                                
                                {   authUser && Authorities.hasPermission(authorities, ACCESO_RESERVADAS) 
                                        ? 
                                            <Form.Group className="col-md-3">
                                                <label htmlFor="privadas">Acceso a reservadas</label>
                                                <Form.Control
                                                    as = "select"
                                                    className = "form-control"  
                                                    disabled = { usersLoading }
                                                    id = "privadas"
                                                    isInvalid = { !!errors.privadas }
                                                    name = "privadas" 
                                                    onChange = { handleChange }
                                                    value = { values.privadas }
                                                >
                                                    <option value="">Seleccione...</option>
                                                    {   binaryData.map( (b,index)=>(
                                                            <option key={`ap-${index}`} value={b.id} >
                                                                { b.descripcion }
                                                            </option>
                                                        ))
                                                    }
                                                </Form.Control>
                                                <Form.Control.Feedback type="invalid">
                                                    { errors.privadas }
                                                </Form.Control.Feedback>
                                            </Form.Group>
                                        : 
                                            null
                                }
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            {   usersLoading 
                                    ? 
                                        <ButtonSpinner />
                                    : 
                                        <Button disabled={usersLoading} type="submit" variant="success" >
                                            <ICON_SAVE /> <strong>{ isEdit ? 'ACTUALIZAR' : 'GUARDAR' }</strong>
                                        </Button>
                            }
                            <Button variant="secondary" onClick={handleCloseForm} disabled={ usersLoading }>
                                <ICON_CANCEL /> Cancelar
                            </Button>
                        </Modal.Footer>
                    </form>
                )}
            </Formik>
        </Modal>
    );
};

export default UserForm;